import styles from "./styles/RightColumnWidget.module.scss";
import { useFeatureFlags } from "../../../utils/featureFlags/useFeatureFlags";
import Leaderboard from "../leaderboard/Leaderboard";
import { LeaderboardEntry } from "../SchoolFeedDisplay";

export default function LeaderboardWidget(props: {
  leaderboardDataPromise: Promise<LeaderboardEntry[]>;
}) {
  const { show_meritocracy_chat } = useFeatureFlags();

  return show_meritocracy_chat ? (
    <div className={styles.widget}>
      <Leaderboard leaderboardDataPromise={props.leaderboardDataPromise} />
    </div>
  ) : null;
}
